import { css } from 'styled-components'

const transparentButtonTemplate = () => css`
  background: transparent;
  color: var(--primary);

  min-width: unset;
  height: auto;
  padding: 0.125rem 0.25rem;

  &:not(:disabled) {
    &:hover {
      color: color-mix(in srgb, var(--primary) 80%, black);
    }
  }

  &.active {
    background: var(--primary);
    color: var(--sl-fg-inverted);

    &:not(:disabled) {
      &:hover {
        background: color-mix(in srgb, var(--primary) 80%, black);
        color: var(--sl-fg-inverted);
      }
    }
  }

  &:disabled {
    color: var(--sl-fg-base-disabled);
    cursor: not-allowed;
  }
`

export default transparentButtonTemplate
